import React from 'react'
import { lang, frameworks, databases, tools } from '../assets/data';
// css -> About.css 


const SkillsSection = () => {
    return (
        <div className='section2 animation'>
            <h1 className='skillTitle'>Skills</h1>
            <div className='skill_container'>
                <div>
                    <h1 className='skilltype'>
                        Languages
                    </h1>
                    <div className='items'>
                        {
                            lang.map((x) => {
                                return (
                                    <span
                                        key={x.key}
                                        className='lang'
                                        data-cursor={true}
                                    >
                                        {x.language}
                                    </span>
                                );
                            })
                        }
                    </div>
                </div>
                <div>
                    <h1 className='skilltype'>
                        Databases
                    </h1>
                    <div className='items'>
                        {
                            databases.map((x) => {
                                return (
                                    <span
                                        key={x.key}
                                        className='lang'
                                        data-cursor={true}
                                    >
                                        {x.language}
                                    </span>
                                );
                            })
                        }
                    </div>
                </div>
                <div>
                    <h1 className='skilltype'>
                        Libraries & Frameworks
                    </h1>
                    <div className='items'>
                        {
                            frameworks.map((x) => {
                                return (
                                    <span
                                        key={x.key}
                                        className='lang'
                                        data-cursor={true}
                                    >
                                        {x.language}
                                    </span>
                                );
                            })
                        }
                    </div>
                </div>
                <div>
                    <h1 className='skilltype'>
                        Tools
                    </h1>
                    <div className='items'>
                        {
                            tools.map((x) => {
                                return (
                                    <span
                                        key={x.key}
                                        className='lang'
                                        data-cursor={true}
                                    >
                                        {x.language}
                                    </span>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SkillsSection
